import React from 'react';
import { t } from '@lingui/macro';
import { ApplicationTable } from 'applicationTable/ApplicationTable';
import { ApplicationTableProvider } from 'applicationTable/ApplicationTable.context';
import { ApplicationTableHeader } from 'applicationTable/applicationTableHeader/ApplicationTableHeader';
import { ApplicationTableStateProvider } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import { useTrackingIdentify } from 'utils/tracking/tracking.hooks';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

import styles from './index.module.css';

export const HomePage = () => {
  useTrackingIdentify();

  return (
    <ApplicationTableStateProvider>
      <ApplicationTableProvider>
        <BaseLayout
          pageTitle={t`Dashboard | Introducer Portal`}
          className={styles.dashboardLayout}
          showDEFooter
        >
          <ApplicationTableHeader />
          <ApplicationTable />
        </BaseLayout>
      </ApplicationTableProvider>
    </ApplicationTableStateProvider>
  );
};
